import script from "./MintAssetControlsCoinDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MintAssetControlsCoinDetails.vue?vue&type=script&setup=true&lang=js"

import "./MintAssetControlsCoinDetails.vue?vue&type=style&index=0&id=60ec0808&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ec0808"]])

export default __exports__